import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-caae4b1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "unlogin"
}
const _hoisted_2 = {
  key: 0,
  class: "label"
}
const _hoisted_3 = {
  key: 1,
  class: "tips"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "link" }, " 点击去绑定 ", -1))
const _hoisted_5 = {
  key: 1,
  class: "has-mobile"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " 我的手机号码 ", -1))
const _hoisted_7 = { class: "mobile" }
const _hoisted_8 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_BindMobileModel = _resolveComponent("BindMobileModel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["footer-ctrl g-fixed", {'large-footer-ctrl': _ctx.isLargeScreen}])
    }, [
      (!_ctx.isLogin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (!_ctx.hasMobile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 为了更好为你提供运输服务，请点击右边按钮登录 "))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "g-button g-button-primary login",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navLogin && _ctx.navLogin(...args)))
            }, " 立即登录 ")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (!_ctx.hasMobile)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "empty-mobile",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleModel && _ctx.toggleModel(...args)))
                }, [
                  _createTextVNode(" 绑定手机号可及时帮您解决问题，请 "),
                  _hoisted_4
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_Icon, {
                      class: "icon",
                      icon: "icon_phone"
                    }),
                    _createElementVNode("text", _hoisted_8, _toDisplayString(_ctx.userInfo.mobile), 1)
                  ]),
                  _createElementVNode("button", {
                    class: "g-button g-button-primary link",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleModel && _ctx.toggleModel(...args)))
                  }, " 修改 ")
                ]))
          ])),
      (_ctx.hasMobile)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "g-button g-button-primary goto-order",
            "hover-class": "hover",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submitOrder && _ctx.submitOrder(...args)))
          }, " 寄包裹 "))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_BindMobileModel, {
      "is-show-model": _ctx.isShowBindMobileModel,
      onClose: _ctx.toggleModel
    }, null, 8, ["is-show-model", "onClose"])
  ], 64))
}